import { render, staticRenderFns } from "./MakeYourTeam.vue?vue&type=template&id=3aef8eec&scoped=true&"
import script from "./MakeYourTeam.vue?vue&type=script&lang=js&"
export * from "./MakeYourTeam.vue?vue&type=script&lang=js&"
import style0 from "./MakeYourTeam.vue?vue&type=style&index=0&id=3aef8eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aef8eec",
  null
  
)

export default component.exports